import type { DatabaseConfig } from '@/types/database';

export const getDatabaseTypeLabel = (type: string) => {
  switch (type) {
    case 'supabase': return 'Supabase';
    case 'mysql': return 'MySQL';
    case 'postgresql': return 'PostgreSQL';
    default: return type;
  }
};

export const getDatabaseTypeBadgeColor = (type: string) => {
  switch (type) {
    case 'supabase': return 'bg-green-500';
    case 'mysql': return 'bg-blue-500';
    case 'postgresql': return 'bg-purple-500';
    default: return 'bg-gray-500';
  }
};

export const getDefaultConfig = (): DatabaseConfig => ({
  id: 'default',
  name: "الإعداد الافتراضي - Supabase",
  type: 'supabase',
  config: {
    url: "https://oensydfsjipboyzupgnm.supabase.co",
    anonKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9lbnN5ZGZzamlwYm95enVwZ25tIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk4NDgxNjQsImV4cCI6MjA2NTQyNDE2NH0.THLfPFRmYmJz-OpmEeK_tfMfmdVGVQTPtR59nc73m0M"
  },
  isActive: true
});

export const copyConfigToClipboard = (config: DatabaseConfig) => {
  let configText = `النوع: ${config.type}\nالاسم: ${config.name}\n`;
  if (config.type === 'supabase') {
    configText += `URL: ${config.config.url}\nAnon Key: ${config.config.anonKey}`;
  } else {
    configText += `المضيف: ${config.config.host}\nالمنفذ: ${config.config.port}\nقاعدة البيانات: ${config.config.database}\nاسم المستخدم: ${config.config.username}`;
  }
  navigator.clipboard.writeText(configText);
};